module.exports = "<mat-icon matTooltip=\"Supprimer\" class=\"close-btn label\">close</mat-icon>\n"